import { Fragment, useState } from 'react';
import { t } from '@lingui/core/macro';
import { Chip } from '@pocketlaw/tetris';
import { RenameDocumentDialog } from 'app/domains/documents';
import { useDocumentMetadata } from './DocumentMetadataProvider';
export function DocumentNameChip() {
    const { data } = useDocumentMetadata();
    const [active, setActive] = useState(false);
    const { systemData, accessLevel } = data;
    const { name } = systemData;
    const restricted = accessLevel !== 'full';
    const toggleAction = () => setActive(!active);
    return (<Fragment>
      <Chip size="medium" label={t({ message: 'Document name', comment: 'Label for document name' })} secondary={name} appearance="secondary" onClick={restricted ? undefined : toggleAction}/>

      {active && <RenameDocumentDialog onClose={() => setActive(false)}/>}
    </Fragment>);
}
